import { render, staticRenderFns } from "./TopTriggerCard.vue?vue&type=template&id=3338efd2&scoped=true&"
import script from "./TopTriggerCard.vue?vue&type=script&lang=js&"
export * from "./TopTriggerCard.vue?vue&type=script&lang=js&"
import style0 from "./TopTriggerCard.vue?vue&type=style&index=0&id=3338efd2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3338efd2",
  null
  
)

export default component.exports